// extracted by mini-css-extract-plugin
module.exports = {"container":"Login_container__zxj4D","logo":"Login_logo__32zQ8"};